import React, { useEffect, useState } from "react";
import LandingLayout from "@/Layouts/LandingLayout";
import { Container } from "@/Components/Container";
import { Inertia } from "@inertiajs/inertia";
import { useTitle } from "@/Utilities/Hooks";
import { LabeledSelectAutocomplete } from "@/Components/Form";
import { ROLE_ID } from "@/Enums/roles";

export default function ChooseAccount({ auth }) {
  useTitle("Choose cccount");

  const [membership, setMembership] = useState(null);

  const memberships = auth.user.data.memberships
    .filter((m) => {
      // Check if agency_id is null or if it is set and its ID does not exist in the memberships array
      return (
        m.agency_id === null ||
        !auth.user.data.memberships.some(
          (items) => items.organization_id === m.agency_id,
        )
      );
    })
    .map((m) => {
      return {
        value: m.id,
        name: m.organization_name,
      };
    });

  useEffect(() => {
    if (memberships.length === 1) {
      Inertia.post(route("auth.select-membership", memberships[0].value));
    }
  }, [memberships]);

  function handleLogin(e) {
    e.preventDefault();

    if (!membership) {
      return;
    }

    Inertia.post(route("auth.select-membership", membership));
  }

  return (
    <Container size="max-w-2xl bg-white self-center md:dots-topright md:dots-bottomleft overflow-visible relative p-4 md:p-16 mt-4 md:mt-10">
      <div className="flex flex-col items-start">
        <h1 className="header-1 mb-2">Choose account</h1>
        <p>You have all the options in the world</p>
      </div>
      <div className="mt-8">
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <LabeledSelectAutocomplete
              name="membership_id"
              title="Sign in to"
              options={memberships}
              className="mb-4 text-gray-700"
              placeholder="Choose account"
              onSelect={(val) => setMembership(val)}
            />
          </div>

          <button disabled={!membership} className="btn ml-auto block">
            Sign in
          </button>
        </form>
      </div>
    </Container>
  );
}

ChooseAccount.layout = (page) => <LandingLayout>{page}</LandingLayout>;
